import React from 'react';
import ReactDOM from 'react-dom/client';
import { captureReferralFromUrl } from './auth/referralCapture';
import './styles/base.css';
import './styles/themes.css';
import './styles/lorath-loaders.css';
import './styles/lorath-siegel.css';
import { App } from './app/App';
import { initChatTextPrefs } from './theme/chatText';

// Bugfix #37: ?ref= aus der URL persistieren BEVOR React Router sie
// normalisiert. Best-effort — auf Native (capacitor://localhost) gibt es
// in der Regel keine Query-Params, dann ist der Aufruf ein no-op.
captureReferralFromUrl();

// R3 (C34): Schriftart/-groesse der Chat-Texte kaltstartfest anwenden (das
// Inline-Script in index.html setzt sie bereits; hier mit Werte-Pruefung).
initChatTextPrefs();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
